import script from "./ClassicalNotComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicalNotComplete.vue?vue&type=script&setup=true&lang=js"

import "./ClassicalNotComplete.vue?vue&type=style&index=0&id=396a1607&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396a1607"]])

export default __exports__